
const  Allprojects = [
        {
            "id":1,
            "image": "https://res.cloudinary.com/dcf4tkmma/image/upload/v1672739666/Untitled_design__1_-removebg-preview_lwwv6q.png",
            "name":"Food Orederning Portal",
            "description":"This is a complete MERN stack website in which user can order the food and all the orders will be send to the mongoDB Atlas",
            "github": "https://www.github.com/nitesh4dev/Food-ordering-portal"
        },
        {
            "id":2,
            "image": "https://res.cloudinary.com/dcf4tkmma/image/upload/v1672739666/Untitled_Project-removebg-preview_aluxlf.png",
            "name":"Grocery App",
            "description":"Although this project look simple because of UI but it has more in backend. Complete CRUD application with MongoDB",
            "github": "https://www.github.com/nitesh4dev/Food-ordering-portal"
        }
    ]

    export default Allprojects;